export enum localStorage {
    ORGANIZATION_ORDERS = 'organization_orders',
}